import { Sort } from '../interfaces/sort';
import { IdentificationPriority } from './identification-priority';
import { SelectionPriority } from './selection-priority';

export class IdentificationSelectionPriority<T extends Record<string, any>>
  implements Sort<T>
{
  constructor(
    public readonly items: T[],
    public readonly selections: T[],
    public readonly key: string
  ) {}

  sort(): T[] {
    const sorted = new IdentificationPriority(this.items, this.key).sort();
    return new SelectionPriority(sorted, this.selections, this.key).sort();
  }
}
